export enum ButtonSidebarInventory {
  DIAGNOSIS = "Diagnostico",
  FEEDBACK_LOOP = "Feedback Loop",
  FEEDBACK_REMO = "Feedback Remo",
}
